import React, { Component } from 'react'
import PropTypes            from 'prop-types'
import Transition           from 'react-transition-group/Transition'
import './index.less'

class PopupCommon extends Component {

  static propTypes = {
    show: PropTypes.bool,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
  }

  handleConfirm() {
    this.props.onConfirm()
  }

  handleCancel() {
    this.props.onCancel()
  }

  getStyle(status) {
    switch (status) {
      case 'entered':
        return {
          opacity: 1,
        }
      case 'entering':
      case 'exiting':
      case 'exited':
      default:
        return {
          opacity: 0,
          pointerEvents: 'none',
        }
    }
  }

  render() {
    const {
      show,
    } = this.props
    return (
      <Transition in={show} timeout={{ enter: 0, exit: 0 }} mountOnEnter unmountOnExit>
        {status =>
          <div className="popup-common-mask">
            <div className={`popup ${status}`}>
              {this.props.children}
            </div>
          </div>
        }
      </Transition>
    )
  }
}

PopupCommon.defaultProps = {
  show: false,
  confirmText: '',
  cancelText: '',
  onConfirm: () => {
  },
  onCancel: () => {
  },
}

export default PopupCommon



// WEBPACK FOOTER //
// ./src/components/PopupCommon/index.js